export default "__VITE_ASSET__74c6ea1a__"